import { STRING_TO_NUMBER_REGEX } from '@components/bid_request/details/constants';

/**
 * This handles reformatting currency strings with a single decimal point to a number with a fixed number of decimal.
 * @param {string} str String upon which to convert, can be '$ 12,323.2', '$123.20', '$123', '123.2', '123, '123.4002'
 * @param {number} digits Number of digits to have after conversion.
 * @returns {number} A string or number formatted with the provided number of digits or a 0.00 float.
 */
export const formatStringAsNumber = (
  str: string,
  digits = 4
): number => {
  if (!str || typeof str !== 'string') return 0.0;

  const newString = str.replace(STRING_TO_NUMBER_REGEX, '');
  const parsedNumber = Number.parseFloat(newString);

  if (Number.isNaN(parsedNumber)) return 0.0;

  return parseFloat(parsedNumber.toFixed(digits));
};
